import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { InvoicesKanban } from 'modules/Kanban/pages/InvoicesKanban';

export const InvoiceKanbanTab = () => {
  const debtor = useDebtor();

  return <InvoicesKanban lockedDebtor={{ id: String(debtor.id), fullName: debtor.full_name }} />;
};
